type UpdateOverlayPositionProps = {
	forceUpdate?: boolean;
};

declare global {
	interface Window {
		__REACT__OVERLAY_POSITION_TS: null | ((UpdateOverlayPositionProps) => void);
	}
}

export const getOffsetTop = () => {
	const { top } = document.documentElement.style;
	const value = Math.abs(parseInt(top, 10));

	return Number.isNaN(value) ? 0 : value;
};

export function updateOverlayPosition(props: UpdateOverlayPositionProps = {}) {
	if (typeof window.__REACT__OVERLAY_POSITION_TS !== 'function') {
		return;
	}

	window.__REACT__OVERLAY_POSITION_TS(props);
}
